import { formatTime } from "../common";

export class TimecodeDisplay {
    private displayElement: HTMLElement;
    public constructor(elementId: string) {
        const element = document.getElementById(elementId);
        if (!element) {
            throw new Error(`Element with id ${elementId} not found`);
        }
        this.displayElement = element;
    }

    public update(timecode: number) {
        this.displayElement.innerText = formatTime(timecode);
    }
}
